import { TableCellProps } from '../../../AdminsTab/AdminsList/models';
import { toDayMonthYear } from '../../../../../../shared/helpers';

export default function LastLoggedIn({ row }: TableCellProps) {
  const { lastLoggedIn } = row.original;
  const renderRegisteredDate = () =>
    lastLoggedIn ? (
      <span>{toDayMonthYear(lastLoggedIn.toString())}</span>
    ) : (
      <span>N/A</span>
    );
  return (
    <div
      className="cell d-flex align-items-center"
      key={`registered-${row.original.personId}`}
    >
      {renderRegisteredDate()}
    </div>
  );
}
